module.exports = __webpack_public_path__ + "static/media/dumpster-fire.824ef9d8.svg";